import { startManualWorkOrderPrintDeliveryJob } from "../../../../../../../../../../../../../../api/kehrblatt/letters"

import type { StartLetterPrintJobOperations } from "../../actions/startLetterPrintJob"

export const startLetterPrintJobOperations: StartLetterPrintJobOperations = {
  startPrintJob: (payload) =>
    startManualWorkOrderPrintDeliveryJob({
      organization_id: payload.organization_id,
      manual_delivery_item_ids: [...payload.manual_delivery_item_ids],
    }),
}
